// src/pages/editor/Dashboard.js
import React from 'react';
import { Box } from '@mui/material';
import Header from './components/Header';
import Sidebar from './components/Sidebar'; // Erstelle ggf. eine separate Sidebar für "editor"
import Content from './components/Content'; // Oder spezifische Komponenten für "editor"

function EditorDashboard() {
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Sidebar links */}
      <Sidebar />

      {/* Hauptinhalt rechts */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',  // Flexbox verwenden, um Header und Content zu stapeln
          height: '100vh',  // Höhe des Hauptinhalts auf die volle Höhe setzen
          overflow: 'auto',  // Scrollen für den Hauptinhalt erlauben, falls nötig
        }}
      >
        {/* Header oben */}
        <Header />

        {/* Inhalt darunter */}
        <Content />
      </Box>
    </Box>
  );
}

export default EditorDashboard;
